import React from 'react';
import {InputText} from "primereact/inputtext";
import AdminFieldLabel from './AdminFieldLabel';

interface AdminInputTextProps {
  label: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  type?: 'text' | 'email' | 'tel';
  name: string;
  id: string;
  className?: string;
  disabled?: boolean;
  languageSwitcher?: React.ReactNode;
  error?: string;
}

const AdminInputText: React.FC<AdminInputTextProps> = ({
                                                         label,
                                                         value,
                                                         onChange,
                                                         onFocus,
                                                         onBlur,
                                                         placeholder,
                                                         required = false,
                                                         type = 'text',
                                                         name,
                                                         id,
                                                         className = '',
                                                         disabled = false,
                                                         languageSwitcher,
                                                         error
                                                       }) => {
  return (
    <div className={className}>
      <AdminFieldLabel
        htmlFor={id}
        label={label}
        required={required}
        languageSwitcher={languageSwitcher}
      />
      <InputText
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        required={required}
        type={type}
        className={`w-full px-4 py-3 border rounded-sm focus:outline-none focus:ring-1 focus:ring-gray-800 focus:border-transparent transition duration-300 ${error ? 'border-red-500' : 'border-gray-300'}`}
        disabled={disabled}
      />
      {error && <small className="block text-red-500 text-xs mt-1">{error}</small>}
    </div>
  );
};

export default AdminInputText;
